const getSelectedAndSemiselectedTagIds = (data = []) => {
  const mapUniqueTags = /* @__PURE__ */ new Map();
  data.map((resource) => resource.tags).flat().forEach((tag) => {
    if (!mapUniqueTags.has(tag.id)) {
      mapUniqueTags.set(tag.id, tag);
    }
  });
  const selectedTags = [];
  const indeterminateTags = [];
  Array.from(mapUniqueTags).forEach(([tagId, tag]) => {
    if (data.every((resource) => resource.tags.find((t) => t.id === tagId))) {
      selectedTags.push(tag);
    } else {
      indeterminateTags.push(tag);
    }
  });
  return {
    selectedTags,
    indeterminateTags
  };
};

export { getSelectedAndSemiselectedTagIds };
//# sourceMappingURL=utils.js.map
